import template from './template.html';

controller.$inject = ['$scope', 'DriversService', 'UserService', '$stateParams'];

export function controller($scope, DriversService, UserService, $stateParams) {
    const vm = this;
    const storeId = $stateParams.storeId;

    vm.drivers = [];
    vm.setSortOrder = setSortOrder;
    vm.isSortedBy = isSortedBy;
    vm.loading = true;
    vm.userCanAdd = false;

    vm.sort = DriversService.driversListState.sortOrder;
    vm.includeDeleted = DriversService.driversListState.includeDeleted;
    vm.searchCriteria = DriversService.driversListState.searchCriteria;

    $scope.$watch('vm.sort', (sortOrder) => {
        DriversService.driversListState.sortOrder = sortOrder;
    });

    $scope.$watch('vm.includeDeleted', (includeDeleted) => {
        DriversService.driversListState.includeDeleted = includeDeleted;
    });

    $scope.$watch('vm.searchCriteria', (searchCriteria) => {
        DriversService.driversListState.searchCriteria = searchCriteria;
    });

    getRoles();

    DriversService.getDrivers().then(drivers => {
        vm.drivers = drivers;
        vm.loading = false;
    });

    function getRoles() {
        UserService.isInRole('AddDriver').then(result => {
            if (result) {
                UserService.isInStore(storeId).then(result => vm.userCanAdd = result);
            }
        });
    }

    function setSortOrder(propertyName) {
        vm.sort = vm.sort === propertyName ? '-' + propertyName : propertyName;
    }

    function isSortedBy(propertyName, direction) {
        if (vm.sort.indexOf(propertyName) >= 0) {
            if (direction == 'desc' && vm.sort.substring(0, 1) == '-') {
                return true;
            }
            if (direction == 'asc' && vm.sort.substring(0, 1) != '-') {
                return true;
            }
        }
        return false;
    }
}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('drivers', {
        controller: controller,
        controllerAs: 'vm',
        parent: 'authorised',
        template: template,
        url: '/drivers',
        params: {
            includeDeleted: false,
            searchCriteria: '',
            sortOrder: 'firstName'
        }
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/authorised/driverlist/index.js